import React from 'react'
import View from './view.js'
import { useDataChange, useDataValue } from 'Simple/Data.js'
import useListItemDataOnChange from './useListItemDataOnChange.js'

export default function Logic(props) {
  let change = useDataChange({
    context: 'automation',
    viewPath: props.viewPath,
    path: 'actions',
  })
  let actions = useDataValue({
    context: 'automation',
    path: 'actions',
    viewPath: props.viewPath,
  })

  function onDragEnd(result) {
    if (!result.destination) {
      return
    }

    // If the item was dropped in the same position, do nothing
    if (result.destination.index === result.source.index) {
      return
    }

    let newItems = Array.from(actions)
    let sourceIndex = result.source.index
    let destinationIndex = result.destination.index

    if (newItems[sourceIndex]?.type === 'wait') {
      let endIndex = sourceIndex

      for (let i = sourceIndex + 1; i < newItems.length; i++) {
        if (newItems[i]?.type === 'wait') break
        endIndex = i
      }

      let blockLength = endIndex - sourceIndex + 1
      let movedBlock = newItems.splice(sourceIndex, blockLength)

      if (destinationIndex > sourceIndex) {
        destinationIndex = destinationIndex - (blockLength - 1)
      }

      newItems.splice(destinationIndex, 0, ...movedBlock)
    } else {
      let [reorderedItem] = newItems.splice(sourceIndex, 1)
      newItems.splice(destinationIndex, 0, reorderedItem)
    }

    newItems = newItems.map((item, index) => ({
      ...item,
      order: index,
    }))

    change(newItems)
  }
  return (
    <View
      {...props}
      onDragEnd={onDragEnd}
      useListItemDataOnChange={useListItemDataOnChange}
    />
  )
}
